
import * as React from 'react';

import {usePlanContext} from '../../context/PlanContext';

import {PlanFormInfoComponent} from './PlanFormInfoComponent';
import {PlanFormPaymentComponent} from './PlanFormPaymentComponent';
import {PlanFormProgramsComponent} from './PlanFormProgramsComponent';
import {PlanFormExternalPlansComponent} from './PlanFormExternalPlansComponent';
import { PlanFormEmail } from './PlanFormEmail.component';
import { useFormContext } from 'react-hook-form';
import { PlanFormValues } from './PlanFormInfo.type';


export function PlanFormComponent() : JSX.Element {

  const {
    loading,
    onSubmit
  } = usePlanContext();

  const {handleSubmit, watch} = useFormContext<PlanFormValues>();

  const planType = watch('planType');

  return(
    <form onSubmit={handleSubmit(onSubmit)}>
      <PlanFormInfoComponent />
      <PlanFormProgramsComponent />
      {planType !== 'gympass' && (
        <>
          <PlanFormPaymentComponent />
          <PlanFormExternalPlansComponent />
        </>
      )}
      <PlanFormEmail />
      <div className="row">
        <div className="col s12"><button className="btn btn-primary right" type="submit" disabled={loading}>Salvar</button></div>
      </div>
    </form>
  )
}